import { DOCS_URL } from "../../../config/constants.js";
import ServiceRelatedWorkCard from "./ServiceRelatedWorkCard.svelte";

export default {
    component: ServiceRelatedWorkCard,
    name: "Service Related Work Card",
    description: "Compact related work card for service pages",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-servicerelatedworkcard--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/briefcase.svg",
    models: ["service-page"],
    hideFromInsertMenu: true,
    requiresParent: {
        message: "Service Related Work Card must be used inside a Service Callout Container.",
        component: "Service Callout Container",
    },
    inputs: [
        { friendlyName: "Eyebrow", name: "eyebrow", type: "string", defaultValue: "Case study" },
        { friendlyName: "Title", name: "title", type: "string", required: true },
        { friendlyName: "Meta 1", name: "metaOne", type: "string" },
        { friendlyName: "Meta 2", name: "metaTwo", type: "string" },
        {
            friendlyName: "Image",
            name: "image",
            type: "object",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "webp"],
                },
                { friendlyName: "Alt", name: "alt", type: "text" },
            ],
        },
        { friendlyName: "Link", name: "link", type: "url" },
    ],
};
